"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base = '/svc/carrental';
/**
 * @private
 */
exports.CARRENTAL_ENDPOINT = {
    getVehicle: base + "/vehicles/{{vehicleVin}}",
    getVehicleSummary: base + "/vehicles/{{vehicleVin}}/summary",
    getVehicleMeasurements: base + "/vehicles/{{vehicleVin}}/measurements{{query}}",
    getVehicleStatusHistory: base + "/vehicles/{{vehicleVin}}/status-history{{query}}",
    vehicleReadingsValidation: base + "/vehicles/{{vehicleVin}}/validate",
    getAlertDetails: base + "/vehicles/{{vehicleUuid}}/alert/{{alertUuid}}",
    postCloseAlert: base + "/vehicles/{{vehicleUuid}}/alert/{{alertUuid}}/close",
    getComments: base + "/vehicles/{{vehicleUuid}}/alert/{{alertUuid}}/comment",
    postComment: base + "/vehicles/{{vehicleUuid}}/alert/{{alertUuid}}/comment",
    putComment: base + "/vehicles/{{vehicleUuid}}/alert/{{alertUuid}}/comment/{{commentUuid}}",
    deleteComment: base + "/vehicles/{{vehicleUuid}}/alert/{{alertUuid}}/comment/{{commentUuid}}",
    postShowLocation: base + "/vehicles/{{vehicleUuid}}/show-location",
    getMapLocationsList: base + "/map/list{{query}}",
    getMapLocationDetails: base + "/map/locations/{{locationUuid}}",
    getMapVehicleDetails: base + "/map/vehicles/{{vehicleUuid}}",
    getFleetCheck: base + "/fleet-check/station/{{stationUuid}}/vehicles",
    postZone: base + "/poi/zone/",
    putZone: base + "/poi/zone/{{zoneUuid}}",
    deleteZone: base + "/poi/zone/{{zoneUuid}}",
    getZones: base + "/poi/zone/filter/station/{{stationUuid}}",
    getVehicleExport: base + "/export?operator={{query}}",
    putActivateVehicle: base + "/vehicles/{{vehicleVin}}/activate",
    putDeactivateVehicle: base + "/vehicles/{{vehicleVin}}/deactivate",
    putDefleetVehicle: base + "/vehicles/{{vehicleVin}}/defleet",
    putInfleetVehicle: base + "/vehicles/{{vehicleVin}}/infleet",
};
